module.exports = __webpack_public_path__ + "img/donante-fvpbc.561d3c80.jpeg";